<template>
    <div class="w">
       <div class="datails_nav">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home" />首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Assume' }">
          揭榜挂帅
        </el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="redTitle">
          <div>
            “揭榜挂帅” 张榜项目 &nbsp;&nbsp;
            <br />
            <span class="redspan"
              >第二届中国·河南河南开放创新暨跨过技术转移大会</span
            >
          </div>
        </div>
         <div class="relevant">
          <div class="head">
            <div class="head">
              <button
                v-for="(i, n) in itemBtn"
                :key="n"
                @click="changeType(n)"
                :class="inde === n ? 'focusBtnStyle' : ''"
                class="layui-btn layui-btn-primary"
              >
                {{ i.name }}
              </button>
            </div>
          </div>
         <div class="show">
            <ul class="clc-ul">
              <li v-for='(item,index) in Zblist' :key='index' @click="ZbList(item.ID)">
									<img class="showimg" v-if='item.IsTechnical===0'
										src="../../assets/Assume-Image/组 4205.png" alt="">
									<img class="showimg" v-else src="../../assets/Assume-Image/组 4206.png" alt="">
									<h3 class="project_title" :class="'contents'+index">{{item.Title}}</h3>
									<template v-if='item.IsTechnical==0'>
										<div class="itemDesc">
											{{item.DemandDescription}}
										</div>
										<div class="project_mes">
											<div class="projpan">—— 单位名称：{{item.CompanyOrPersonName}}
											</div>
										</div>
									</template>

									<template v-else>
										<div class="itemDesc">
											{{item.ResultsInformation}}
										</div>
										<div class="project_mes">
											<div></div>
											<div class="prov">—— 单位名称：{{item.CompanyOrPersonName}}
											</div>
										</div>
									</template>

								</li>
            </ul>
          </div>
        </div>

        <yedeng
            :limit.sync="datalist.pageSize"
            :page.sync="datalist.page"
            :total="total"
            v-if="total > 1"
            @pagination="Zbitems"
        >
        </yedeng>
    </div>
</template>
<script>
import "../../assets/Ass-css/guashui.css"
import yedeng from '../library/components/Pagination/index.vue'
import { getAction, postAction } from "@/api/api";
import qs from "qs";
import { ZhangBangList } from "@/api/url";
 export default{
     data(){
         return{
             itemBtn: [
                {
                name: "全部",
                },
                {
                name: "技术攻关类",
                },
                {
                name: "成果转化类",
                },
            ],
            inde:0,
            datalist:{
                action: "Get_ZhangBangList",
                sort: "ID ASC",
                IsSigned: 1,
                pageSize: 12,
                page:1,
                IsTech:null
            },
            Zblist:[],
            total:0
         }
     },
     created(){
         this.Zbitems()
     },
     methods:{
         changeType(n){
             this.inde=n
             if(n<=0){
                 this.datalist.IsTech=null
             }else{
                 this.datalist.IsTech=n-1
             }
              getAction(ZhangBangList, this.datalist).then((res) => {
                this.Zblist=res.data
                this.handleCurrentChange(1)
            });
         },
         Zbitems(){
             getAction(ZhangBangList, this.datalist).then((res) => {
                this.Zblist=res.data
                this.total=res.count
            });
         },
         ZbList(item){
             let routeData = this.$router.resolve({
              path: "/ZbData",
              query: {
              list: item,
              },
            });
            window.open(routeData.href, "_blank");
            },
            handleCurrentChange(val){
                this.datalist.page=val
                this.Zbitems()
            },
            pre(){
              this.$refs.yeing.prev();
            },
            nex(){
               this.$refs.yeing.next();
            },
            infine(){
              this.Zbitems()
            }            
     },
     computed:{
       bant(){
         if(this.datalist.page !==1){
           return false
         }else{
           return true
         }
       }
     },
     components:{
       yedeng
     }
 }
</script>

<style scoped>
body {
  margin: 0rem;
  font-family: Microsoft YaHei;
  left: 0rem;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  box-sizing: border-box;
}

.w {
  width: 80rem;
  margin: 3rem auto 5rem;
  height: auto;
  overflow: hidden;
  position: relative;
}

#header {
  height: 7.4375rem;
  border-bottom: 0.0625rem solid #ffffffa9;
  background-color: #222222;
  width: 100%;
}
.datails_nav {
  text-align: left;
  height: 5.125rem;
  line-height: 5.125rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}

.datails_nav .layui-breadcrumb a {
  color: #999 !important;
}
.lang {
  margin: 0 .625rem;
  color: rgb(8, 8, 8);
}
.redTitle{
    position: relative;
    color: #333;
    height: 11rem;
    width: 40rem;
    margin: 0 auto 0;
    overflow: hidden;
}
.redTitle>div{
    text-align: center;
    font-size: 2rem;
    line-height: 3rem;
    height: auto;
    top: 2rem;
    margin: auto;
}
.redspan{
  font-size: 0.875rem;
  color: rgba(51, 51, 51, 0.5);
}
.relevant ul li{
    width: 24rem !important;
}
.show li:hover h3{
	color: #308BEC;
}
::v-deep .btn-prev,.btn-next{
  background: none !important;
  border-radius: 0.3125rem !important;
}
::v-deep .el-pager li{
  z-index: 9999;
  width:2.5rem !important;
  border-radius: 0.3125rem !important;
}
::v-deep .el-pagination__jump{
  margin-left: 3rem !important;
}
.prov{
  margin-right: 1.875rem; 
  line-height:1.7rem;
}
.head{
  text-align:left;
}
.showimg{
  height: 5.625rem;
  width:100%;
}
.projpan{
  margin-right: 1.875rem;
  line-height: 1.5rem;
}
.itemDesc{
  z-index: 99;
  margin:0 0.9rem 0.9rem;
  height: 4.5rem;
  line-height: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.show ul{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.show ul li{
  height: 21rem !important;
  cursor: pointer;
}
.show ul li h3{
  z-index: 99;
  padding:0.9375rem !important;
  height: 4rem !important;
  font-size: 1.125rem !important;
  text-align: left;
}
.project_mes{
  margin: 0 !important;
  padding:0.9rem !important;
  text-align: left;

}
.clc-ul::after{
  content: '';
  display:block;
  width: 24rem;
}
</style>